<template>
  <div>
    <div class="table_td_title">
      <div :style="{ 'width': Phone?`25%`:`10%` }">
        {{ $t(`lang.str_hashbettype`) }}
      </div>
      <div  :style="{ 'width': Phone?`75%`:`90%` }">
        <div class="gameImgArea_5">
          <div class="box" v-for="(itemBase, indexBase) in [[1, 2], [2, 2], [3, 6], [4, 8], [5, 8], [6, 12], [7, 6], [8, 8], [9, 8], [10, 12], [11, 48], [12, 24]]" :key="indexBase">
            <div  v-if="Number(new Map(Object.entries(winpos.BetsInfo).map(([key, value]) => [value.betPos, value.betAmount])).get(itemBase[0])) > 0" >
              <div v-for="(item, index) in new Map(Object.entries(winpos.BetsInfo).map(([key, value]) => [value.betPos, value]))" :key="index">
                <div v-if="itemBase[0] == item[0]">
                  <div v-if="item[0] == 1 || item[0] == 2" class="img_container img_container2">
                    <div class="img_container_bg" :style="{ 'background': `url(${require('../../assets/fqzs/path_bg.png')})`, 'background-size': '100% 100%', }" v-if="item[0] == 1">飞禽</div>
                    <div class="img_container_bg" :style="{ 'background': `url(${require('../../assets/fqzs/path_bg.png')})`, 'background-size': '100% 100%'}" v-else>走兽</div>
                  </div>
                  <div v-else class="img_container" >
                    <img style="height: 80%; width: 80%;" :src="require('../../assets/fqzs/' + item[0] + '.png')" alt="" :class="{ deep: true }">
                  </div>
                </div>
                <div v-if="itemBase[0] == item[0]">
                  <p v-if="item[1].betAmount > 0">{{(parseFloat(item[1].betAmount).toFixed(2) / 100).toFixed(2)}} x{{itemBase[1]}}</p>
                  <p v-else  class="gray_color">0 x {{itemBase[1]}}</p>
                  <p class="yellow_color" v-if="item[1].winAmount > 0">+{{(parseFloat(item[1].winAmount).toFixed(2) / 100).toFixed(2)}}</p>
                  <p v-else>-</p>
                </div>
              </div>
            </div>
            <div v-else>
              <div v-if="itemBase[0] == 1 || itemBase[0] == 2" class="img_container img_container2">
                <div  class="img_container_bg" :style="{ 'background': `url(${require('../../assets/fqzs/path_bg.png')})`, 'background-size': '100% 100%', 'opacity': 0.2 }" v-if="itemBase[0] == 1">飞禽</div>
                <div  class="img_container_bg" :style="{ 'background': `url(${require('../../assets/fqzs/path_bg.png')})`, 'background-size': '100% 100%', 'opacity': 0.2 }" v-else>走兽</div>
              </div>
              <div v-else class="img_container">
                <img style="height: 80%; width: 80%;" :src="require('../../assets/fqzs/' + itemBase[0] + '.png')" alt="" :class="{ deep: false }">
              </div>
              <p class="gray_color">0 x {{itemBase[1]}}</p>
              <p>-</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="table_td_title">
      <div :style="{ 'width': Phone?`25%`:`10%`, 'vertical-align': 'center'}">
        {{ $t(`lang.str_hashresult`) }}
      </div>
      <div :style="{ 'width': Phone?`75%`:`90%` }">
        <div style="width:90%;">
          <div class="gameImgArea_result">
            <div style="height: 80px; padding-right:20px;">
              <div v-if="winpos.HitAnimal1 == 12 || winpos.HitAnimal1 == 26" class="img_container"  :style="{ 'background': `url(${require('../../assets/fqzs/path_bg.png')})`, 'background-size': '100% 100%' }">
                <div style="text-align: center;">{{ getFQZSWinType(winpos.HitAnimal2) }} {{ getFQZSWinType(winpos.HitAnimal1) }}</div>
              </div>
              <div v-else class="img_container" :style="{  'width': '100px', 'background': `url(${require('../../assets/fqzs/path_bg.png')})`, 'background-size': '100% 100%' }">
                <div style="text-align: center;">{{ getFQZSWinType(winpos.HitAnimal1) }}</div>
              </div>
            </div>
            <div style="height: 80px; padding-right:20px;">
              <div v-if="winpos.HitAnimal1 == 12 || winpos.HitAnimal1 == 26"  class="img_container" >
                <img style="height: 80%; width: 80%;" :src="require('../../assets/fqzs/' + getFQZSWinPos(winpos.HitAnimal2) + '.png')" alt="" :class="{ deep: true }">
              </div>
              <div v-else  class="img_container">
                <img style="height: 80%; width: 80%;" :src="require('../../assets/fqzs/' + getFQZSWinPos(winpos.HitAnimal1) + '.png')" alt="" :class="{ deep: true }">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DescribeLayout
      :winValueTip="winValueTip"
      :winValueTotal="winValueTotal"
      :isTotalWin="isTotalWin"
      :describe_title = "describe_title"
      :describe_content = "describe_content"
      :describe_message="describe_message">

    </DescribeLayout>

  </div>
</template>
<script>
import DescribeLayout from "../common/describe_layout.vue";
import Game3011 from "./game_3011.vue";

export default {
  name: "Game3012",
  components: {Game3011, DescribeLayout},
  props:{
    winValueTip:null,
    winValueTotal:null,
    isTotalWin:false,
    describe_title:null,
    describe_content:null,
    describe_message:null,
    winpos:0,
    lang: '',
    Phone:false,
  },
  data()
  {
    return {

    }
  },
  methods: {

    getFQZSWinPos(index) {
      switch(index) {
        case 0:
          return 7;
        case 1:
          return 6;
        case 2:
          return 5;
        case 3:
          return 4;
        case 4:
          return 3;
        case 5:
          return 11;
        case 6:
          return 7;
        case 7:
          return 8;
        case 8:
          return 9;
        case 9:
          return 10;
        case 10:
          return 6;
        case 11:
          return 5;
        case 12:
          if(this.getlang != 'zh_cn')
          {
            return "乐园"
          } else {
            return "樂園"
          };
        case 13:
          return 4;
        case 14:
          return 3;
        case 15:
          return 10;
        case 16:
          return 9;
        case 17:
          return 8;
        case 18:
          return 7;
        case 19:
          return 12;
        case 20:
          return 3;
        case 21:
          return 4;
        case 22:
          return 5;
        case 23:
          return 6;
        case 24:
          return 10;
        case 25:
          return 9;
        case 26:
          if(this.getlang != 'zh_cn')
          {
            return "乐园"
          } else {
            return "樂園"
          };
        case 27:
          return 8;
      }
    },

    getFQZSWinType(index) {
      var fq = "飞禽";
      var zs = "走兽";
      var sy = "鲨鱼";
      var ly = "乐园";
      if(this.lang != 'zh_cn')
      {
        fq = "飛禽";
        zs = "走獸";
        sy = "鯊魚";
        ly = "樂園";
      }
      switch(index) {
        case 0:
          return zs;
        case 1:
          return fq;
        case 2:
          return fq;
        case 3:
          return fq;
        case 4:
          return fq;
        case 5:
          return sy;
        case 6:
          return zs;
        case 7:
          return zs;
        case 8:
          return zs;
        case 9:
          return zs;
        case 10:
          return fq;
        case 11:
          return fq;
        case 12:
          return ly;
        case 13:
          return fq;
        case 14:
          return fq;
        case 15:
          return zs;
        case 16:
          return zs;
        case 17:
          return zs;
        case 18:
          return zs;
        case 19:
          return sy;
        case 20:
          return fq;
        case 21:
          return fq;
        case 22:
          return fq;
        case 23:
          return fq;
        case 24:
          return zs;
        case 25:
          return zs;
        case 26:
          return ly;
        case 27:
          return zs;
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/esports/game_3012.vue